<template>
  <div class="m-0 dbozone-font bg-moemoe" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-moemoe">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -moemoe`">{{ $t('3_5_bonus_20.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_7.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class="font-weight-bold text-sub mt-5" :class="`-${lang}`">{{$t('3_5_bonus_20.paytable.symtable_wild1')}}
            <br>{{$t('3_5_bonus_20.paytable.symtable_wild2')}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-3 align-items-center p-0 d-flex ml-2">
          <span class="font-weight-bold text-sub mt-5" :class="`-${lang}`">{{$t('3_5_bonus_20.paytable.symtable_wild1')}}
            <br>{{$t('4_5_base.paytable.symtable_scatter')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_6.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[6][4]}}
            <br>{{'4 - ' + paytable[6][3]}}
            <br>{{'3 - ' + paytable[6][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_5.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[5][4]}}
            <br>{{'4 - ' + paytable[5][3]}}
            <br>{{'3 - ' + paytable[5][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[4][4]}}
            <br>{{'4 - ' + paytable[4][3]}}
            <br>{{'3 - ' + paytable[4][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[3][4]}}
            <br>{{'4 - ' + paytable[3][3]}}
            <br>{{'3 - ' + paytable[3][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[2][4]}}
            <br>{{'4 - ' + paytable[2][3]}}
            <br>{{'3 - ' + paytable[2][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[1][4]}}
            <br>{{'4 - ' + paytable[1][3]}}
            <br>{{'3 - ' + paytable[1][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_0.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[0][4]}}
            <br>{{'4 - ' + paytable[0][3]}}
            <br>{{'3 - ' + paytable[0][2]}}
          </span>
        </div>

        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">

        </div>
      </div>
      <div class="d-flex flex-column nav-moemoe mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -moemoe`">{{ $t('moemoe.multiplier-title') }}</h5>
        </section>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/moemoe/normal_multiplier.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.multiplier-text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.multiplier-text2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.multiplier-text3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.multiplier-text4') }}</span>
      </div>

      <div class="d-flex flex-column nav-moemoe mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -moemoe`">{{ $t('moemoe.freespin-title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-3 justify-content-center d-flex flex-row">
            <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_8.png`)"
            alt="">
        </div>
        <div class="col-3 justify-content-center d-flex flex-row">
            <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_8.png`)"
            alt="">
        </div>
        <div class="col-3 justify-content-center d-flex flex-row">
            <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/resultGame/moemoe/symbol_8.png`)"
            alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.freespin-text1') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/moemoe/freespin_multiplier.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.freespin-text2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('moemoe.freespin-text3') }}</span>
      </div>

       <div class="d-flex flex-column nav-moemoe mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -moemoe`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
       <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/moemoe/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
       <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-moemoe mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -moemoe`">{{ $t('3_5_bonus_20.line') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-3">
        <span class="m-0 text-sub">{{ $t('3_5_bonus_20.text-line1') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub">{{ $t('3_5_bonus_20.text-line2') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/pay/3_5_freespin_20_line.png`)"
          alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-moemoe',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.content {
  background: #000013;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>